import React, { useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import { Form } from 'react-bootstrap';
import { t } from 'i18next';
import Image from '../../../public/img/icons8-tick.gif';
import { useTranslation } from 'react-i18next';

const ModalCartSuccessful = ({
  setGridModalOpen,
  gridModalOpen,
  modalMessageText,
  modalExist,
  onDelete,
  isDelete,
  selectRecordId,
}) => {
  const [data, setData] = useState(true);
  const { t } = useTranslation();
  // const [modalMessage,setModalMessage] = useState({
  //   added:"main",
  //   exist:true
  // })

  const handleSubmit = (event) => {
    event.preventDefault();
  };
  return (
    <MDBModal show={gridModalOpen} onHide={() => setGridModalOpen(false)}>
      <MDBModalDialog>
        <MDBModalContent>
          {/* Move the Form component outside the ModalHeader */}
          <Form className="items-center" onSubmit={handleSubmit}>
            <MDBModalHeader className="items-center">
              <MDBBtn type="button" className="btn-close" color="none" onClick={() => setGridModalOpen(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className="">
              <div className="container-fluid flex bd-example-row items-center flex-col justify-center">
                {/* <img src={Image} alt="gif" /> */}
                <div className="wrapper">
                  {/* Success Icon */}
                  {!modalExist ? (
                    <>
                      {' '}
                      <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        {' '}
                        <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />{' '}
                        <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                      </svg>
                    </>
                  ) : (
                    <svg
                      className="w-5 h-5"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"></path>
                    </svg>
                  )}

                  {/* Already Icon */}
                </div>

                <div>
                  <p className={!modalExist ? 'text-customgreen' : 'text-red-500'}>{t(modalMessageText)}</p>
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter className="items-center justify-center">
              {isDelete ? (
                <div className="">
                  <button
                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center ms-1"
                    type="submit"
                    color="secondary"
                    onClick={() => {onDelete(selectRecordId?.id), setGridModalOpen(false);}}
                  >
                    {t('Delete')}
                  </button>
                  <button
                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center ms-1"
                    type="submit"
                    color="secondary"
                    onClick={() => setGridModalOpen(false)}
                  >
                    {t('Close')}
                  </button>
                </div>
              ) : (
                <button
                  className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center ms-1"
                  type="submit"
                  color="secondary"
                  onClick={() => setGridModalOpen(false)}
                >
                  {t('Ok')}
                </button>
              )}
            </MDBModalFooter>
          </Form>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

export default ModalCartSuccessful;
